import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PayrollOverviewMobile from "./pages/Payroll/PayrollOverviewMobile";
import { useDispatch, useSelector } from "react-redux";
import { setMobileResponse } from "./features/appMobileSlice";
import PendingSummaryMobile from "./pages/Payroll/PendingSummaryMobile";
import ValidationPopupMobile from "./components/ValidationPopupMobile";
import CryptoJS from "crypto-js";
import {
  addNotifications,
  triggerPayrollRefresh,
} from "./features/webSocketSlice";
import PayrollMobile from "./pages/Payroll/PayrollMobile";
import CashAdvancePendingApproval from "./pages/Payroll/QuickPayPendingApproval";
import CashAdvancePendingApprovalMobile from "./pages/Payroll/CashAdvancePendingApprovalMobile";

const IdentityValue = process.env.REACT_APP_IDENTITY_VALUE;
const secretKey = process.env.REACT_APP_SECRET_KEY;

const aesDecrypt = (encryptedText, encryptionKey) => {
  try {
    const iv = CryptoJS.enc.Utf8.parse(IdentityValue);
    const key = CryptoJS.enc.Utf8.parse(encryptionKey);
    const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

function AppMobile({ parameters }) {
  const [urlData, setUrlData] = useState({
    id: null,
    ts: null,
    secure: null,
    reference: null,
    device: null,
    action: null,
  });

  const dispatch = useDispatch();

  const mobileMessage =
    useSelector((state) => state.appData.mobileResponse) === "back";

  const deviceType = useSelector((state) => state.appData.deviceType);

  const [decryptedWebSocketUrl, setDecryptedWebSocketUrl] = useState("");
  const webSocketClientRef = useRef(null);
  const encryptedWebSocketUrl = useSelector(
    (state) => state.websocket.websocket
  );

  useEffect(() => {
    let encryptedUrl = encryptedWebSocketUrl;
    if (!encryptedUrl) {
      encryptedUrl = localStorage.getItem("encryptedWebSocketUrl");
    } else {
      localStorage.setItem("encryptedWebSocketUrl", encryptedUrl);
    }
    if (!encryptedUrl) return;

    const decryptedUrl = aesDecrypt(encryptedUrl, secretKey);
    if (!decryptedUrl) {
      console.error("Failed to decrypt WebSocket URL");
      return;
    }
    setDecryptedWebSocketUrl(decryptedUrl);

    const ws = new WebSocket(decryptedUrl);

    ws.onopen = () => {
      console.log("WebSocket Connected!");
    };

    ws.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);

        const payload = message.Payload ? JSON.parse(message.Payload) : null;

        dispatch(addNotifications({ ...message, Payload: payload }));

        if (message.Event === "Refresh GetPayrollSubmitted API") {
          dispatch(triggerPayrollRefresh());
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    ws.onclose = () => {
      console.log("WebSocket connection closed.");
    };

    webSocketClientRef.current = ws;

    return () => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.close();
        console.log("WebSocket connection closed during cleanup.");
      }
    };
  }, [encryptedWebSocketUrl]);

  useEffect(() => {
    dispatch(setMobileResponse(""));
    window.handleCheckout = (message) => {
      dispatch(setMobileResponse(message));
    };

    if (mobileMessage) {
      if (deviceType === "Android") {
        window.AndroidInterface.callbackHandler("GoToApp");
      } else if (deviceType === "Iphone") {
        window.webkit.messageHandlers.callbackHandler.postMessage("GoToApp");
      }
    }
  });

  useEffect(() => {
    window.handleCheckout = (message) => {
      dispatch(setMobileResponse(message));
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/payroll/:id/:ts/:ref/:device/:action/:sh"
          // element={<PayrollOverviewMobile setUrlData={setUrlData} />}
          element={<PayrollMobile setUrlData={setUrlData} />}
        />
        <Route
          path="/quickpay/:id/:ts/:ref/:device/:action/:sh"
          element={<CashAdvancePendingApprovalMobile setUrlData={setUrlData} />}
        />
      </Routes>
      <ValidationPopupMobile />
    </BrowserRouter>
  );
}

export default AppMobile;
